import React from "react";
import Column from "../../../../components/DataTable/models/Column";
import CompanyRow from "../models/CompanyRow";
import { LinkText } from "../../../../components/Common/hyperlinks";
import { CompanyUrls } from "../../index";
import { getUsername, isBRCGSUser } from "../../../../Authentication/Auth";

const IsUserExist = getUsername();

const companyColumns: Column<CompanyRow>[] = [
  {
    title: "ID",
    field: "id",
  },
  {
    title: "Company",
    field: "name",
    render: (rowData: CompanyRow) => (
      <LinkText link={CompanyUrls.details(rowData.id)} text={rowData.name} />
    ),
  },
  {
    title: "Country",
    field: "country",
    filtering: true,
  },
  {
    title: "City",
    field: "city",
  },
  {
    title: "Related Sites",
    field: "sites",
  },
   ...(IsUserExist && isBRCGSUser()
    ? [
        {
          title: "Audit Shared",
          field: "auditShared" as keyof CompanyRow,
        },
      ]
    : []),
  {
    title: "Status",
    field: "status",
  },
  {
    title: "Max Favourites",
    field: "maxFavouriteLimit",
    // filtering: true

  },
  {
    title: "Type",
    field: "type",
    // filtering: true
  }
];

export default companyColumns;
